(function() {
  'use strict';
  
  console.log('🎯 Gallery fix - FINAL approach');
  
  let targetIndex = null;
  
  // Watch for lightbox appearing
  const observer = new MutationObserver(function(mutations) {
    if (targetIndex === null) return;
    
    const lightbox = document.querySelector('.product-image-zoom-container');
    if (!lightbox || lightbox.style.display === 'none') return;
    
    console.log('👁️ Lightbox detected!');
    
    const slidesContainer = lightbox.querySelector('.glide__slides');
    if (!slidesContainer) return;
    
    const slides = slidesContainer.querySelectorAll('.glide__slide');
    if (slides.length === 0) return;
    
    console.log('📸 Found', slides.length, 'slides in lightbox');
    
    // Calculate transform
    const firstSlide = slides[0];
    const slideWidth = firstSlide.offsetWidth;
    const style = window.getComputedStyle(firstSlide);
    const marginLeft = parseInt(style.marginLeft) || 0;
    const marginRight = parseInt(style.marginRight) || 0;
    const totalWidth = slideWidth + marginLeft + marginRight;
    
    const translateX = -(totalWidth * targetIndex);
    
    console.log('✅ Setting transform:', translateX, 'px (slide width:', totalWidth, ')');
    
    slidesContainer.style.transition = 'transform 400ms cubic-bezier(0.165, 0.84, 0.44, 1)';
    slidesContainer.style.transform = 'translate3d(' + translateX + 'px, 0px, 0px)';
    
    // Keep reapplying for 1 second to fight resets
    let count = 0;
    const keepApplying = setInterval(function() {
      if (slidesContainer.style.transform !== 'translate3d(' + translateX + 'px, 0px, 0px)') {
        console.log('🔄 Reapplying transform');
        slidesContainer.style.transform = 'translate3d(' + translateX + 'px, 0px, 0px)';
      }
      count++;
      if (count >= 10) clearInterval(keepApplying);
    }, 100);
    
    targetIndex = null;
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  
  // Intercept clicks
  function fixGallery() {
    const slides = document.querySelectorAll('#product-media-slider .glide__slide[data-image-zoom-toggle]');
    console.log('📸 Found zoomable slides:', slides.length);
    
    slides.forEach(function(slide) {
      slide.addEventListener('click', function(e) {
        const index = parseInt(this.getAttribute('data-image-index'));
        targetIndex = index;  // NO OFFSET - use raw index
        
        console.log('🖱️ Clicked image:', index, '| Setting targetIndex:', targetIndex);
      }, true);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixGallery);
  } else {
    fixGallery();
  }
  
  setTimeout(fixGallery, 1000);
  
})();